import { Button } from '@/components'
import { FeedbackTitle } from '../feedbackItem'
import { useLocation, useNavigate } from 'react-router-dom'
import { FeedbackEditor } from './feedbackEditor'
import { MenuHeader } from '@/pages/menu/menuHeader'
import { useEffect, useRef, useState } from 'react'
import { GolfBizNm, GolfInfoData } from '@/pages/promotion/promotionItem'
import { useAxios } from '@/context/axiosContext'
import { useResponsive } from '@/hooks/useResponsive'

export const InsertFeedback = () => {
  const axios = useAxios()
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)

  const [nameList, setNameList] = useState<GolfBizNm[]>([])
  const { isMobile, isTablet, isDesktop } = useResponsive()
  useEffect(() => {
    getGolfNameList()
  }, [])

  const getGolfNameList = async () => {
    try {
      const response = await axios.get(`/promotion/getGolfNameList`, {
        headers: { 'Cache-Control': 'no-cache' },
      })

      const { golfNameList } = response.data.data

      const seenBizCds = new Set<string>()
      const nameList: GolfBizNm[] = golfNameList
        .filter((item: GolfInfoData) => {
          const isValid = item.remark?.trim()
          const isUnique = !seenBizCds.has(item.bizCd || '')

          if (isValid && isUnique) {
            seenBizCds.add(item.bizCd || '')
            return true
          }
          return false
        })
        .map((item: GolfInfoData) => ({
          areaCd: item.areaCd?.trim(),
          bizNm: item.bizNm?.trim(),
          bizCd: item.bizCd,
        }))

      setNameList(nameList) // 골프장명리스트
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  return (
    <>
      {!isMobile && (
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={true}
          menuInfoRef={menuInfoRef}
          loginRequired={true}
          iconActive={hasMenuInfo}
        />
      )}
      <FeedbackEditor nameList={nameList} />
    </>
  )
}
